import Vue from "vue";
import Router from "vue-router";
import i18n from "@/i18n";
Vue.use(Router);

/* Layout */
import Layout from "@/layout";
import { getLang } from "@/utils/lang";
i18n.locale = getLang() || "zh";
export var constantRoutes = [{
  path: "/",
  redirect: "/layout"
}, {
  path: "/layout",
  component: Layout
}, {
  path: "/login",
  name: "login",
  component: function component() {
    return import("@/views/login/index");
  },
  hidden: true
}, {
  path: "/404",
  component: function component() {
    return import("@/views/404");
  },
  hidden: true
}, {
  path: "/register",
  name: "Register",
  component: function component() {
    return import("@/views/register/index");
  },
  hidden: true
}, {
  path: "/success",
  name: "success",
  component: function component() {
    return import("@/views/registerSuccess/index");
  },
  hidden: true
}, {
  path: "/personResetPassword",
  name: "PersonResetPassword",
  component: function component() {
    return import("@/views/personResetPassword/index");
  },
  hidden: true
}, {
  path: "/personRegister",
  name: "PersonRegister",
  component: function component() {
    return import("@/views/personRegister/index");
  },
  hidden: true
}, {
  path: "/wallet",
  component: Layout,
  children: [{
    path: "/",
    component: function component() {
      return import("@/views/wallet/index");
    },
    meta: {
      title: i18n.t("router.wallet")
    },
    children: [{
      path: "WalletBalance",
      name: "WalletBalance",
      component: function component() {
        return import("@/views/wallet/WalletBalance");
      },
      meta: {
        title: i18n.t("finance.walletBalance")
      }
    }, {
      path: "DepositRecords",
      name: "ChargeRecord",
      component: function component() {
        return import("@/views/wallet/ChargeRecord");
      },
      meta: {
        title: i18n.t("finance.provision")
      }
    }, {
      path: "address",
      name: "WithdrawAddress",
      component: function component() {
        return import("@/views/wallet/WithdrawAddress/index");
      },
      meta: {
        title: i18n.t("wallet.withdraw_address")
      }
    }, {
      path: "WithdrawalHistory",
      name: "ReferrerWithdraw",
      component: function component() {
        return import("@/views/wallet/Withdraw/index");
      },
      meta: {
        title: i18n.t("referrer.withdrawRecord")
      }
    }, {
      path: "sharedAccount",
      name: "sharedAccount",
      component: function component() {
        return import("@/views/wallet/ShareAccount");
      },
      meta: {
        title: i18n.t("wallet.shareAccount")
      }
    }]
  }]
}, {
  path: "/finance",
  component: Layout,
  children: [{
    path: "/",
    component: function component() {
      return import("@/views/finance/index");
    },
    children: [{
      path: "CardRecharge",
      name: "CardCharge",
      component: function component() {
        return import("@/views/finance/CardCharge");
      },
      meta: {
        title: i18n.t("finance.card")
      }
    }, {
      path: "AuthorizationFeeDeduction",
      name: "AuthorizationFeeDeduction",
      component: function component() {
        return import("@/views/finance/AuthorizationFeeDeduction");
      },
      meta: {
        title: i18n.t("finance.card")
      }
    }, {
      path: "cardBuyCryptoCurrency",
      name: "CardBuyCryptoCurrency",
      component: function component() {
        return import("@/views/finance/CardBuyCryptoCurrency");
      },
      meta: {
        title: i18n.t("finance.cardBuyCryptoCurrency")
      }
    }, {
      path: "DeductionHistory",
      name: "ReduceRecord",
      component: function component() {
        return import("@/views/finance/ReduceRecord");
      },
      meta: {
        title: i18n.t("wallet.reduceRecord")
      }
    }, {
      path: "InstitutionBalance",
      name: "Balance",
      component: function component() {
        return import("@/views/finance/Balance");
      },
      meta: {
        title: i18n.t("finance.balance")
      }
    }, {
      path: "ReserveFunds",
      name: "ReserveDeposit",
      component: function component() {
        return import("@/views/finance/ReserveDeposit");
      },
      meta: {
        title: i18n.t("finance.deposit")
      }
    }, {
      path: "SalaryBonus",
      name: "Salary",
      component: function component() {
        return import("@/views/finance/Salary");
      },
      meta: {
        title: i18n.t("finance.salary")
      }
    }, {
      path: "WithdrawalHistory",
      name: "NpayWithdrawRecord",
      component: function component() {
        return import("@/views/finance/WithdrawRecord.vue");
      },
      meta: {
        title: i18n.t("npay.withdrawRecord")
      }
    },
    // {
    //   path: "WithdrawalHistory",
    //   name: "NpayWithdrawRecord",
    //   component: () => import("@/views/finance/NpayWithdrawRecord"),
    //   meta: { title: i18n.t("npay.withdrawRecord") },
    // },
    {
      path: "UserAssets",
      name: "UserAssets",
      component: function component() {
        return import("@/views/finance/UserAssets");
      },
      meta: {
        title: i18n.t("finance.userAsset")
      }
    }]
  }]
}, {
  path: "/settings",
  component: Layout,
  children: [{
    path: "/",
    component: function component() {
      return import("@/views/settings/index");
    },
    children: [{
      path: "api",
      name: "api",
      component: function component() {
        return import("@/views/settings/ApiManagement/index");
      },
      meta: {
        title: i18n.t("settings.api_title")
      }
    }, {
      path: "webhooks",
      name: "webhooks",
      component: function component() {
        return import("@/views/settings/WebHooks/index");
      },
      meta: {
        title: i18n.t("settings.api_title")
      }
    }, {
      path: "address",
      name: "address",
      // component: () => import("@/views/settings/AddressManage/index"),
      component: function component() {
        return import("@/views/wallet/WithdrawAddress/index");
      },
      meta: {
        title: i18n.t("settings.api_title")
      }
    }]
  }]
}, {
  path: "/card",
  component: Layout,
  children: [{
    path: "/",
    component: function component() {
      return import("@/views/card/index");
    },
    children: [{
      path: "openingRecord",
      name: "openingRecord",
      component: function component() {
        return import("@/views/card/ApplyRecord/index");
      },
      meta: {
        title: i18n.t("settings.api_title")
      }
    }]
  }]
}, {
  path: "*",
  redirect: "/404",
  hidden: true
}, {
  path: "/query",
  name: "query",
  component: function component() {
    return import("@/views/query/index");
  },
  hidden: true
}];
var createRouter = function createRouter() {
  return new Router({
    scrollBehavior: function scrollBehavior() {
      return {
        y: 0
      };
    },
    routes: constantRoutes
  });
};
var router = createRouter();
export function resetRouter() {
  var newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}
export default router;